import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    accessToken: "",
    hrInfo: {
      isHr: "N", // Y, N
      hrKey: "",
    },
    companyLogo: "",
    idxLeSiteMain: null,
    hideHeader: false,
    idxCompany: null,
    isCancleFunction: null,
    userId: "",
    isQuestion: false,
  },
  getters: {
    getAccessToken(state) {
      return state.accessToken;
    },
    getCompanyLogo(state) {
      return state.companyLogo;
    },
    getIdxLeSiteMain(state) {
      return state.idxLeSiteMain;
    },
    getIdxCompany(state) {
      return state.idxCompany;
    },
  },
  mutations: {
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken;
    },
    setCompanyLogo(state, logo) {
      state.companyLogo = logo;
    },
    setIdxLeSiteMain(state, idxLeSiteMain) {
      state.idxLeSiteMain = idxLeSiteMain;
    },
    setHideHeader(state, value) {
      state.hideHeader = value;
    },
    setIdxCompany(state, idxCompany) {
      state.idxCompany = idxCompany;
    },
    setIsCancleFunction(state, value) {
      state.isCancleFunction = value;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setHrInfo(state, hrInfo) {
      state.hrInfo = hrInfo;
    },
    setIsQuestion(state, value) {
      state.isQuestion = value;
    },
  },
  actions: {
    setCompanyLogo({ commit }, logo) {
      commit("setCompanyLogo", logo);
    },
  },
  plugins: [
    createPersistedState({
      key: "LifeEduUserVuex",
    }),
  ],
});
